var _a, _b;
import { TYPES } from '../../utils/FormikTextField';
export var nameGeolocalisation = 'Geolocalisation';
var Activite = {
    'ClientId': { 'type': TYPES.SELECT, 'libelle': 'Client', 'asyncOptions': 'clients' },
    'ActiviteTypeId': { 'type': TYPES.SELECT, 'libelle': 'Type' },
    'Etat': { 'type': TYPES.SELECT, 'libelle': 'État' },
    'Resultat': { 'type': TYPES.SELECT, 'libelle': 'Résultat' },
    'DateDebut': { 'type': TYPES.TEXT, datetimePicker: true, 'libelle': 'Date de début' },
    'DateFin': { 'type': TYPES.TEXT, datetimePicker: true, 'libelle': 'Date de fin' },
    'Tags': { 'type': TYPES.SELECT, 'libelle': 'Tags' }
};
var Affaire = {
    'ClientId': { 'type': TYPES.SELECT, 'libelle': 'Client', 'asyncOptions': 'clients' },
    'CollaborateurId': { 'type': TYPES.SELECT, 'libelle': 'Collaborateur', 'asyncOptions': 'collaborateurs' },
    'AffaireTypeId': { 'type': TYPES.SELECT, 'libelle': 'Type' },
    'ProbabiliteTypeId': { 'type': TYPES.SELECT, 'libelle': 'Probabilité' },
    'Etat': { 'type': TYPES.SELECT, 'libelle': 'État' },
    'Libelle': { 'type': TYPES.TEXT, 'libelle': 'Libelle' },
    'NumeroDocument': { 'type': TYPES.TEXT, 'libelle': 'Numéro du devis' },
    'TitreDocument': { 'type': TYPES.TEXT, 'libelle': 'Titre du devis' },
    'DateDocument': { 'type': TYPES.TEXT, 'libelle': 'Date du devis' },
    'DateDebut': { 'type': TYPES.TEXT, datePicker: true, 'libelle': 'Date de début' },
    'DateFin': { 'type': TYPES.TEXT, datePicker: true, 'libelle': 'Date de fin' },
    'MoisSignature': { 'type': TYPES.SELECT, 'libelle': 'Mois signature' },
    'DateCloture': { 'type': TYPES.TEXT, datetimePicker: true, 'libelle': 'Date de clôture' },
    'Tags': { 'type': TYPES.SELECT, 'libelle': 'Tags' }
};
var Collaborateur = (_a = {
        'CollaborateurTypeId': { 'type': TYPES.SELECT, 'libelle': 'Type' },
        'Nom': { 'type': TYPES.TEXT, 'libelle': 'Nom' },
        'Prenom': { 'type': TYPES.TEXT, 'libelle': 'Prénom' },
        'Email': { 'type': TYPES.TEXT, 'libelle': 'Email' },
        'Telephone': { 'type': TYPES.TEXT, 'libelle': 'Téléphone' },
        'Mobile': { 'type': TYPES.TEXT, 'libelle': 'Mobile' },
        'Pays': { 'type': TYPES.SELECT, 'libelle': 'Pays' },
        'Ville': { 'type': TYPES.TEXT, 'libelle': 'Ville' },
        'CodePostal': { 'type': TYPES.TEXT, 'libelle': 'Code postal' },
        'Adresse': { 'type': TYPES.TEXT, 'libelle': 'Adresse' },
        'Tags': { 'type': TYPES.SELECT, 'libelle': 'Tags' }
    },
    _a[nameGeolocalisation] = { 'type': 'geolocalisation', 'libelle': 'Géolocalisation' },
    _a);
var Client = (_b = {
        'ClientTypeId': { 'type': TYPES.SELECT, 'libelle': 'Type' },
        'Etat': { 'type': TYPES.SELECT, 'libelle': 'État' },
        'Siret': { 'type': TYPES.TEXT, 'libelle': 'Siret' },
        'RaisonSociale': { 'type': TYPES.TEXT, 'libelle': 'Raison sociale' },
        'Nom': { 'type': TYPES.TEXT, 'libelle': 'Nom' },
        'Prenom': { 'type': TYPES.TEXT, 'libelle': 'Prénom' },
        'Email': { 'type': TYPES.TEXT, 'libelle': 'Email' },
        'Telephone': { 'type': TYPES.TEXT, 'libelle': 'Téléphone' },
        'Mobile': { 'type': TYPES.TEXT, 'libelle': 'Mobile' },
        'TrancheEffectif': { 'type': TYPES.SELECT, 'libelle': 'Tranche d\'éffectif' },
        'CodeNafApeId': { 'type': TYPES.SELECT, 'libelle': 'Code Naf-Ape' },
        'Tags': { 'type': TYPES.SELECT, 'libelle': 'Tags' },
        'Pays': { 'type': TYPES.SELECT, 'libelle': 'Pays' },
        'Ville': { 'type': TYPES.TEXT, 'libelle': 'Ville' },
        'CodePostal': { 'type': TYPES.TEXT, 'libelle': 'Code postal' },
        'Adresse': { 'type': TYPES.TEXT, 'libelle': 'Adresse' }
    },
    _b[nameGeolocalisation] = { 'type': 'geolocalisation', 'libelle': 'Géolocalisation' },
    _b);
var Contact = {
    'ContactTypeId': { 'type': TYPES.SELECT, 'libelle': 'Type' },
    'Nom': { 'type': TYPES.TEXT, 'libelle': 'Nom' },
    'Prenom': { 'type': TYPES.TEXT, 'libelle': 'Prénom' },
    'Email': { 'type': TYPES.TEXT, 'libelle': 'Email' },
    'Telephone': { 'type': TYPES.TEXT, 'libelle': 'Téléphone' },
    'Mobile': { 'type': TYPES.TEXT, 'libelle': 'Mobile' },
};
var Modules = {
    Activite: Activite,
    Affaire: Affaire,
    Collaborateur: Collaborateur,
    Contact: Contact,
    Client: Client
};
export { Modules };
//# sourceMappingURL=format.js.map